import { render, staticRenderFns } from "./TestResultMore.vue?vue&type=template&id=271cbce4&scoped=true&"
import script from "./TestResultMore.vue?vue&type=script&lang=js&"
export * from "./TestResultMore.vue?vue&type=script&lang=js&"
import style0 from "./TestResultMore.vue?vue&type=style&index=0&id=271cbce4&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271cbce4",
  null
  
)

export default component.exports